/**
 * if target value is undefined/null/empty string
 */
export function isEmpty(value) {
    if (value === undefined || value === null || value === '') {
        return true;
    }
    return false;
}
//# sourceMappingURL=IsEmpty.js.map